import { Component, OnInit } from '@angular/core';
// import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClassModalComponent } from '../../modals/class-modal/class-modal.component';
import { DataService } from 'src/app/providers/data.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ClassService } from 'src/app/providers/class/class.service';
import { ShowHideDirective } from '@angular/flex-layout';
import { DeleteConfirmDialogComponent } from 'src/app/shared/delete-confirm-dialog/delete-confirm-dialog.component';
import { ClassStudentModalComponent } from '../../modals/class-student-modal/class-student-modal.component';

interface DialogData {
  email: string;
}

@Component({
  selector: 'app-class',
  templateUrl: './class.component.html',
  styleUrls: ['./class.component.scss']
})

export class ClassComponent implements OnInit{
 public classData;

  constructor(public dialog: MatDialog, 
    public classService: ClassService) { 
      this.getclassData();
    }

  openDialogClass(): void {
    const dialogRef = this.dialog.open(ClassModalComponent, {
      width: '600px',
      data: {
        title: 'Create new class'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getclassData();
    });
  }

  getclassData() {
    this.classService.viewClass()
      .pipe(map(
        data => { return data }
      )).subscribe(
        data => {
          this.classData = data;
          console.log(this.classData);
        });    
  }

  ngOnInit(): void {
    this.getclassData();
    // this.dataClassList$ = this.dataService.ClassList;
    // this.dataService.getClassData().subscribe();
  }

  // editing class set
  editClass(classObj) {
    console.log("editing",classObj);
    const dialogRef = this.dialog.open(ClassModalComponent, {
      width: '600px',
      data: {
        id: classObj.sysRef,
        level_sysref: classObj.level_SysRef,
        supervisor_sysref: classObj.supervisor_SysRef,
        className: classObj.className,
        title: 'Edit class ' + classObj.className,
        subjects: classObj.subjects
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      this.getclassData();
    });

  }

  // deleting a class
  deleteClass(classObj): void {
    const dialogRef = this.dialog.open(DeleteConfirmDialogComponent, {
      width: '350px',
      data: {
        component: 'class',
        id: classObj.sysRef,
        title: 'Confirm Delete',
        message: 'Are you sure, you want to remove class: ' + classObj.className
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getclassData();
    });
  }

  assignedStudents(classObj): void {
    const dialogRef = this.dialog.open(ClassStudentModalComponent, {
      width: '500px',
      data: {
        class: classObj,
        title: 'Add Student to "' + classObj.className +'"'
      }
    })

    dialogRef.afterClosed().subscribe(result => {
      this.getclassData();
    })
  }
}
